import { render, staticRenderFns } from "./PageNotificationSettings.vue?vue&type=template&id=f6201e70&scoped=true&"
import script from "./PageNotificationSettings.vue?vue&type=script&lang=ts&"
export * from "./PageNotificationSettings.vue?vue&type=script&lang=ts&"
import style0 from "./PageNotificationSettings.vue?vue&type=style&index=0&id=f6201e70&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6201e70",
  null
  
)

export default component.exports